var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconPause21 = function SvgIconPause21(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2B328C",
    d: "M1.972 38.024h7.7V1.977h-7.7v36.047zM0 40h11.643V0H0v40zm20.328-1.976h7.7V1.977h-7.7v36.047zM18.357 40H30V0H18.357v40z"
  })));
};
export default SvgIconPause21;